import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddInspectorFeedbackMutationVariables = Types.Exact<{
  input: Types.Inspector_Feedback_Insert_Input;
}>;


export type AddInspectorFeedbackMutation = { __typename?: 'mutation_root', insert_inspector_feedback_one?: { __typename?: 'inspector_feedback', id: any, job_id: any, finding_id?: any | null, gap_item_id?: any | null, user_id: string, accurate?: boolean | null, decision?: string | null, error_attribution?: string | null, comment?: string | null, created_at: any, updated_at: any } | null };


export const AddInspectorFeedbackDocument = gql`
    mutation addInspectorFeedback($input: inspector_feedback_insert_input!) {
  insert_inspector_feedback_one(object: $input) {
    id
    job_id
    finding_id
    gap_item_id
    user_id
    accurate
    decision
    error_attribution
    comment
    created_at
    updated_at
  }
}
    `;
export type AddInspectorFeedbackMutationFn = Apollo.MutationFunction<AddInspectorFeedbackMutation, AddInspectorFeedbackMutationVariables>;

/**
 * __useAddInspectorFeedbackMutation__
 *
 * To run a mutation, you first call `useAddInspectorFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddInspectorFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addInspectorFeedbackMutation, { data, loading, error }] = useAddInspectorFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddInspectorFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<AddInspectorFeedbackMutation, AddInspectorFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddInspectorFeedbackMutation, AddInspectorFeedbackMutationVariables>(AddInspectorFeedbackDocument, options);
      }
export type AddInspectorFeedbackMutationHookResult = ReturnType<typeof useAddInspectorFeedbackMutation>;
export type AddInspectorFeedbackMutationResult = Apollo.MutationResult<AddInspectorFeedbackMutation>;
export type AddInspectorFeedbackMutationOptions = Apollo.BaseMutationOptions<AddInspectorFeedbackMutation, AddInspectorFeedbackMutationVariables>;